export default "__VITE_ASSET__Bl$UZCcq__"